<template>
	<div
		v-if="texts.length"
		class="absolute top-0 left-0 px-4 py-1 text-base flex items-center justify-center"
		:style="{
			color: specialPrice?.text,
			backgroundColor: specialPrice?.background
		}"
	>
		<div>
			<div v-for="{ id, text } in texts" :key="id">{{ text }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { SpecialPrice } from "~/types/storyblok/storyblok";
import type { PromotionTextProduct } from "~/utils/promotions/promotionTexts";

/** [GF-71] Same markup as `SpecialPriceLabel`. */
interface Props {
	product?: PromotionTextProduct | null;
	specialPrice?: SpecialPrice | null;
}
const { product, specialPrice = null } = defineProps<Props>();

const { getPromotionTexts } = usePromotionTexts();
const texts = computed(() => getPromotionTexts(product));
</script>
